import { type ProblemReportState } from "./state";

export const initialState: ProblemReportState = {
  isSubmitting: false,
  submitError: "",
};
